module.exports = __webpack_public_path__ + "img/mastercard_logo.4fd99838.png";